<template>
<div>
    <invoice-code-report-detail-form :getClientsInvoiceCodeList="getLawServiceList" ref="lawServiceFormModal"></invoice-code-report-detail-form>
    <law-ledes-excel-read-form :getLawServiceList="getLawServiceList" ref="lawLedesExcelReadFormModal" :lawLedesId="this.lawLedesId"></law-ledes-excel-read-form>
    <law-service-log-list-form ref="lawServiceLogListFormModal"></law-service-log-list-form>
    <b-alert v-if="rows.length === 0 && !hideExcelButton" show variant="warning" class="p-1">
        {{ $t('lawLedes.no_custom_code_warning') }}
    </b-alert>
    <b-row>
        <b-col class="col-12">
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="showLogList()">{{ $t('lawLedes.change_history') }}</b-button>
                    </div>
                </b-form-group>
                <b-form-group v-if="rows.length === 0 && !hideExcelButton">
                    <div class="d-flex align-items-center">
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="readExcel()">{{ $t('lawLedes.add_from_excel') }}</b-button>
                    </div>
                </b-form-group>
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('others.add') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="lawLedesServiceTable" ref="lawLedesServiceTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :select-options="{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                disableSelectInfo: true, // disable the select info panel on top
                selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
              }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'code'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.code') }}
            </span>
            <span v-else-if="props.column.field === 'name'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.name') }}
            </span>
            <span v-else-if="props.column.field === 'lawServiceType'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.service_type') }}
            </span>
            <span v-else-if="props.column.field === 'description'" class="text-nowrap">
                {{ $t('clientsInvoiceCode.description') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap"></span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'description'">
                <div v-b-tooltip.hover="{ title: props.row.description, customClass: 'wh-tooltip' }" class="wh-clamp-2">{{ props.row.description }}</div>
            </span>
            <span v-else-if="props.column.field === 'code'">
                {{ props.row.code }}
            </span>
            <span v-else-if="props.column.field === 'name'">
                {{ props.row.name }}
            </span>
            <span v-else-if="props.column.field === 'lawServiceType'">
                {{ props.row.lawServiceType }}
            </span>
            <span v-else-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }} </span>
                    <b-form-select v-model="pageLength" :options="['10','50','100', '1000']" class="mx-1" @input="(value)=>props.perPageChanged({currentPerPage:value})" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value)=>props.pageChanged({currentPage:value})">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    props: {
        lawLedesId: Number,
        clientAccountingId: Number,
        onRowsLoaded: {
            type: Function
        },
        hideExcelButton: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [{
                    label: this.$t('clientsInvoiceCode.code'),
                    field: `code`,
                },
                {
                    label: this.$t('clientsInvoiceCode.name'),
                    field: `name`,
                },
                {
                    label: this.$t('clientsInvoiceCode.service_type'),
                    field: `lawServiceType`,
                },
                // STOCK-2972 Ucret Turu artik excel yuklemesinde zorunlu, listede de gosteriliyor.
                {
                    label: this.$t('clientsInvoiceCode.law_costing_type'),
                    field: `lawCostingType`,
                },
                {
                    label: this.$t('clientsInvoiceCode.description'),
                    field: `description`,
                },
                {
                    label: '',
                    field: 'process',
                    width: '8em',
                    sortable: false
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    watch: {
        clientAccountingId() {
            this.getLawServiceList()
        }
    },
    mounted() {
        this.getLawServiceList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'LawService'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                        this.getLawServiceList()
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.lawServiceFormModal.showInfo(id, 0, this.clientAccountingId)
        },
        async showLogList() {
            this.$refs.lawServiceLogListFormModal.showInfo(this.clientAccountingId)
        },
        async readExcel() {
            this.$refs.lawLedesExcelReadFormModal.showInfo(this.lawLedesId)
        },
        getLawServiceList() {
            this.rows = []
            if (!(this.clientAccountingId > 0)) {
                if (this.onRowsLoaded) {
                    this.onRowsLoaded(0)
                }
                return
            }
            const data = {
                id: this.clientAccountingId
            }
            const controller = {
                name: 'LawService',
                actionName: 'GetLawServiceListByClientAccountingId'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.lawServiceList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                if (this.onRowsLoaded) {
                    this.onRowsLoaded(this.rows.length)
                }
            })
        },
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
